export const DARK_MODE_STORAGE_KEY = "metx-dark-mode";
export const DATA_THEME_ATTR = "data-theme";
export const LIGHT_THEME = "light";
export const DARK_THEME = "dark";
